class CourseSteps {

  constructor() {
    this.headers = document.querySelectorAll('.step__header');
    this.listen();
  }

  listen() {
    this.headers.forEach(header => {
      header.addEventListener('click', ev => {
        if (!header.classList.contains('step__header--current')) {
          document.querySelector('.step__header--current').classList.remove('step__header--current');
          header.classList.add('step__header--current');
          let currentStep = ev.target.closest('header').id.slice(-1);
          document.querySelector('.step--current').classList.remove('step--current');
          document.querySelector(`#content_${currentStep}`).classList.add('step--current')
        }
      })
    })
  }

}

export default CourseSteps;